"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPUploader = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_dropzone_1 = require("react-dropzone");
require("../../assets/style.css");
var strings_json_1 = __importDefault(require("../../globals/strings.json"));
var styles_1 = require("./styles");
var ProgressBar_1 = __importDefault(require("./components/ProgressBar"));
var UploadError_1 = __importDefault(require("./components/UploadError"));
var PPUploader = function (props) {
    var classes = (0, styles_1.useStyles)();
    var _a = react_1.default.useState([]), filesList = _a[0], setfilesList = _a[1];
    var _b = react_1.default.useState([]), fileErrorList = _b[0], setFileErrorList = _b[1];
    var maxSize = props.maxSize ? props.maxSize * 1024 : 2048 * 1024;
    var onDrop = react_1.default.useCallback(function (accFiles, rejFiles) {
        if (rejFiles.length > 0) {
            setFileErrorList(rejFiles);
        }
        else {
            setfilesList(accFiles);
            props.onDropFile(accFiles);
        }
    }, []);
    var onDelete = function () {
        setfilesList([]);
        setFileErrorList([]);
        props.onDropFile([]);
    };
    var _c = (0, react_dropzone_1.useDropzone)({
        onDrop: onDrop,
        // accept: ["image/*", "video/*", ".pdf"],
        accept: props.fileTypes === '*' ? '' : props.fileTypes,
        maxSize: maxSize,
    }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive, isDragAccept = _c.isDragAccept, isDragReject = _c.isDragReject;
    return (react_1.default.createElement(core_1.Grid, { id: props.id },
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.Grid, __assign({ container: true }, getRootProps({
                className: isDragActive === true ? classes.active : classes.uploaderContainerDashed,
            })),
                filesList.length > 0 && (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "space-evenly", alignItems: "center" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(ProgressBar_1.default, { cancelLabel: props.cancelLabel || strings_json_1.default.strings.uploader.Cancel, loadMessage: props.loadMessage || strings_json_1.default.strings.uploader.Loading, successIcon: props.successIcon || "ppi ppi-check", uploadIcon: props.uploadIcon || "ppi ppi-cloud-upload", deleteIcon: props.deleteIcon || "ppi ppi-trash", onDelete: onDelete, files: filesList })))),
                fileErrorList.length > 0
                    ? react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "space-evenly", alignItems: "center", style: { marginTop: "10%" } },
                        react_1.default.createElement(UploadError_1.default, { errorIcon: props.errorIcon
                                ? props.errorIcon
                                : "ppi ppi-error_outline", deleteIcon: props.deleteIcon ? props.deleteIcon : "ppi.ppi-trash", file: fileErrorList[fileErrorList.length - 1].file, errors: fileErrorList[fileErrorList.length - 1].errors, onDelete: onDelete, largeFile: props.largeFile, fileTypeNotAllowed: props.fileTypeNotAllowed, defaultError: props.defaultError }))
                    : null,
                fileErrorList.length === 0 && filesList.length === 0 && (react_1.default.createElement(core_1.Grid, { container: true, direction: "column", style: { alignItems: "center" } },
                    react_1.default.createElement("input", __assign({}, getInputProps())),
                    react_1.default.createElement(core_1.Grid, { container: true, className: classes.uploaderNoFileGrid },
                        react_1.default.createElement("i", { className: "".concat(props.uploadIcon ? props.uploadIcon : "ppi ppi-cloud-upload", " colorIcon"), id: "uploadIcon" })),
                    react_1.default.createElement(core_1.Typography, { className: classes.uploaderNoFileTypo }, props.promptMessage
                        ? props.promptMessage
                        : strings_json_1.default.strings.uploader.Drop_File),
                    (isDragReject || isDragAccept || isDragActive) === true ? (react_1.default.createElement(core_1.Button, { id: "form_".concat(props.id, "_selecioneoarquivo_button"), variant: "contained", disabled: true, size: "small", className: classes.uploaderButton1 }, props.selectLabel
                        ? props.selectLabel
                        : strings_json_1.default.strings.uploader.Select_File)) : (react_1.default.createElement(core_1.Button, { size: "small", className: classes.uploaderButton2 }, props.selectLabel
                        ? props.selectLabel
                        : strings_json_1.default.strings.uploader.Select_File))))))));
};
exports.PPUploader = PPUploader;
